
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../vue-loader/lib/style-rewriter?id=data-v-320ab4c5!sass-loader?sourceMap!../../../vue-loader/lib/selector?type=styles&index=0!./SweetModalTab.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./SweetModalTab.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-320ab4c5!../../../vue-loader/lib/selector?type=template&index=0!./SweetModalTab.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/sweet-modal-vue/src/components/SweetModalTab.vue
// module id = 698
// module chunks = 1